import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import PageHero from '../components/PageHero'
import SectionTitle from '../components/SectionTitle'
import { values } from '../data'

export default function About() {
  return (
    <>
      <PageHero eyebrow="About Qubispark" title="We turn emerging technology into practical human capability." text="Qubispark Technologies is a learning and innovation company helping students, educators and organizations understand, apply and build with modern AI technologies." image="https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1400&q=88" imageAlt="A facilitator working with a collaborative learning group" metric="Learn. Apply. Build." metricLabel="Our promise to every learner" />
      <section className="section">
        <div className="container split-copy">
          <SectionTitle eyebrow="Why we exist" title="The technology moves fast. Learning should move people forward." />
          <div><p>Access to AI tools is growing, but access alone does not create skill. People need context, practice, feedback and the confidence to use technology meaningfully.</p><p>We create experiences that make sophisticated ideas approachable, then move quickly into application. The result is not just awareness—it is the ability to ask better questions, build useful workflows and solve real problems.</p></div>
        </div>
      </section>
      <section className="section values-section">
        <div className="container">
          <SectionTitle eyebrow="Our approach" title="Learning principles that guide every engagement." text="From a two-hour workshop to a multi-week academy, these beliefs shape the experience." />
          <div className="value-grid">
            {values.map(({ icon: Icon, title, text }, index) => <article key={title}><span>0{index + 1}</span><Icon size={26} /><h3>{title}</h3><p>{text}</p></article>)}
          </div>
        </div>
      </section>
      <section className="section story-section">
        <div className="container story-grid">
          <div><span className="eyebrow">Who we serve</span><h2>One technology landscape. Different learning realities.</h2></div>
          <div className="story-points">
            <p><strong>Students</strong><span>need a clear path from curiosity to employable, demonstrable capability.</span></p>
            <p><strong>Professors</strong><span>need practical ways to understand and integrate fast-moving tools.</span></p>
            <p><strong>Corporate teams</strong><span>need relevance to roles, workflows and business outcomes.</span></p>
            <p><strong>Institutions</strong><span>need a partner who can translate ambition into scalable learning.</span></p>
          </div>
        </div>
      </section>
      <section className="section compact-cta"><div className="container"><h2>Explore the learning journey.</h2><Link to="/programs" className="text-link">View programs <ArrowRight size={18} /></Link></div></section>
    </>
  )
}
